<template>
  <div class="agents-stats-wrapper">
    <ulu-agents-range-table />
  </div>
</template>

<script>
export default {
  components: {
    "ulu-agents-range-table": () =>
      import("@/components/dashboard/agents/AgentsRangeTable")
  }
};
</script>

<style scoped>
.agents-stats-wrapper {
  background-color: transparent;
}
</style>
